export type LocaleIncludesOptions = Intl.CollatorOptions & {
    /** Starting index to search from (clamped to [0, string.length]) */
    position?: number;
    /** BCP 47 language tag(s) passed to Intl.Collator */
    locales?: string | string[];
};

/**
 * Locale-aware substring check using Intl.Collator.
 * Throws if `string` or `searchString` is null/undefined.
 */
export function localeIncludes(
    string: string,
    searchString: string,
    { position = 0, locales, ...collatorOptions }: LocaleIncludesOptions = {}
): boolean {
    if (string == null || searchString == null) {
        throw new Error("localeIncludes requires at least 2 parameters");
    }

    const stringLength = string.length;
    const searchStringLength = searchString.length;

    if (searchStringLength === 0) return true;
    if (searchStringLength > stringLength) return false;

    let i = Math.max(0, Math.min(position | 0, stringLength)); // coerce to int
    const last = stringLength - searchStringLength;
    const collator = new Intl.Collator(locales, collatorOptions);

    for (; i <= last; i++) {
        if (collator.compare(string.slice(i, i + searchStringLength), searchString) === 0) {
            return true;
        }
    }

    return false;
}
